window.youtube = {
	player: null,

	stop: function () {
		youtube.player.pauseVideo();
		// console.log("video paused");
	},

	resume: function () {
		youtube.player.playVideo();
		// console.log("video resumed");
	}

}

window.onYouTubeIframeAPIReady = function() {
	var our_origin = ROOT;
	window.youtube.player = new YT.Player('background-video', {
		videoId: 'UiZ4K380ZOg', // YouTube Video ID
		width: 1920,
		height: 1080,
		playerVars: {
			playlist: 'UiZ4K380ZOg',
			autoplay: 1,        // Auto-play the video on load
			autohide: 1,
			disablekb: 1,
			controls: 0,        // Hide pause/play buttons in player
			showinfo: 0,        // Hide the video title
			modestbranding: 1,  // Hide the Youtube Logo
			loop: 1,            // Run the video in a loop
			fs: 0,              // Hide the full screen button
			rel: 0,
			enablejsapi: 1,
			origin: our_origin
		},
		events: {
			'onReady': function(e) {
				e.target.setPlaybackQuality('hd1080');
				console.log("ready");
				e.target.mute();
				console.log("start quality: " + e.target.getPlaybackQuality())
				// e.target.setPlaybackQuality('auto');
				e.target.playVideo();
				console.log("set quality: " + e.target.getPlaybackQuality())
				console.log("play");
			},
			'onStateChange': function(e) {
				if(e) {
					if(e.data === 1) {
						e.target.setPlaybackQuality('hd1080');
						console.log("quality: " + e.target.getPlaybackQuality());
						console.log(e.target.getAvailableQualityLevels());
					}
				}

				if(e && e.data === 0){
					e.target.setPlaybackQuality('hd1080');
					e.target.playVideo()
				}
			},
			'onPlaybackQualityChange': function (e) {
				console.log("quality change: " + e.data);
				console.log(e.target.getAvailableQualityLevels());
			}
		}
	});	
}

